// Author Lin
// Date 2021-11-20 09:38:51

class MintalMesPrdPelletizingBallingParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                bn401 = '',
                bn402 = '',
                bn403 = '',
                bn404 = '',
                cakeQuantity = '',
                firstBentonite = '',
                secondBentonite = '',
                limestonePowder = '',
                dustRemovalAsh = '',
                sludgeRecovery = '',
                strongMixingWater = '',
                strongMixingLevel = '',
                pelletizerFrequency = '',
                cv405 = '',
                cv503 = '',
                cv407 = '',
                feedingQuantity = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.bn401 = bn401;
            this.bn402 = bn402;
            this.bn403 = bn403;
            this.bn404 = bn404;
            this.cakeQuantity = cakeQuantity;
            this.firstBentonite = firstBentonite;
            this.secondBentonite = secondBentonite;
            this.limestonePowder = limestonePowder;
            this.dustRemovalAsh = dustRemovalAsh;
            this.sludgeRecovery = sludgeRecovery;
            this.strongMixingWater = strongMixingWater;
            this.strongMixingLevel = strongMixingLevel;
            this.pelletizerFrequency = pelletizerFrequency;
            this.cv405 = cv405;
            this.cv503 = cv503;
            this.cv407 = cv407;
            this.feedingQuantity = feedingQuantity;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingBallingParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn401',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.bn401',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn402',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.bn402',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn403',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.bn403',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bn404',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.bn404',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cakeQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.cakeQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstBentonite',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.firstBentonite',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondBentonite',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.secondBentonite',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'limestonePowder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.limestonePowder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dustRemovalAsh',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.dustRemovalAsh',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'sludgeRecovery',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.sludgeRecovery',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'strongMixingWater',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.strongMixingWater',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'strongMixingLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.strongMixingLevel',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pelletizerFrequency',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.pelletizerFrequency',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cv405',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.cv405',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cv503',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.cv503',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cv407',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.cv407',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'feedingQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.feedingQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            bn401Filter : '',
            bn402Filter : '',
            bn403Filter : '',
            bn404Filter : '',
            cakeQuantityFilter : '',
            firstBentoniteFilter : '',
            secondBentoniteFilter : '',
            limestonePowderFilter : '',
            dustRemovalAshFilter : '',
            sludgeRecoveryFilter : '',
            strongMixingWaterFilter : '',
            strongMixingLevelFilter : '',
            pelletizerFrequencyFilter : '',
            cv405Filter : '',
            cv503Filter : '',
            cv407Filter : '',
            feedingQuantityFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'bn401',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.bn401',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn402',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.bn402',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn403',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.bn403',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bn404',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.bn404',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cakeQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.cakeQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstBentonite',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.firstBentonite',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondBentonite',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.secondBentonite',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'limestonePowder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.limestonePowder',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dustRemovalAsh',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.dustRemovalAsh',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'sludgeRecovery',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.sludgeRecovery',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'strongMixingWater',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.strongMixingWater',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'strongMixingLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.strongMixingLevel',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pelletizerFrequency',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.pelletizerFrequency',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cv405',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.cv405',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cv503',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.cv503',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cv407',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.cv407',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'feedingQuantity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.feedingQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingBallingParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingBallingParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        